import { render } from "./DetailAlice.vue?vue&type=template&id=65e8b207&scoped=true"
import script from "./DetailAlice.vue?vue&type=script&lang=js"
export * from "./DetailAlice.vue?vue&type=script&lang=js"

import "./DetailAlice.vue?vue&type=style&index=0&id=65e8b207&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65e8b207"

export default script